module.exports = __webpack_public_path__ + "img/cover-mick-mix.a9b7ad3e.png";